const initialState = () => ({
  messages: {},
})

export const state = initialState()

export const getters = {
  list: (state) => Object.values(state.messages),
}

export const mutations = {
  ADD_ERROR(state, payload) {
    state.messages = {
      ...state.messages,
      ...payload,
    }
  },
  REMOVE_ERROR(state, key) {
    delete state.messages[key]
    state.messages = {
      ...state.messages,
    }
  },

  RESET(state) {
    state.messages = {}
  },
}

export const actions = {
  /**
   * Reset state
   * @param {*} { commit }
   */
  reset({ commit }) {
    commit('RESET')
  },
  /**
   * Add error message for 5s before removing it
   */
  addError({ commit }, message) {
    if (!message) {
      return
    }

    const key = Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)

    commit('ADD_ERROR', {
      [key]: message,
    })
    setTimeout(() => {
      commit('REMOVE_ERROR', key)
    }, 1000 * 5)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
